import { type ReactNode } from 'react'
import { type PermissionListItem } from '@terros/common'
import { Radio } from '@mantine/core'
import { getRadioOptionProps, stringifyPermissionScope } from './util'
import { type PermissionAllowedScope } from './types'

export const PermissionRadioOption = ({
  optionEditInfo,
  entity,
  disabled: forceDisabled,
  onSelect,
}: {
  optionEditInfo: PermissionListItem
  entity: PermissionAllowedScope
  disabled?: boolean
  onSelect: () => void
}): ReactNode => {
  const { checked, disabled, isDefault } = getRadioOptionProps(optionEditInfo, entity)
  if (entity === 'none') return null

  return (
    <Radio
      checked={checked}
      description={isDefault ? '(default)' : undefined}
      disabled={forceDisabled || disabled}
      key={entity}
      label={stringifyPermissionScope(entity)}
      onChange={onSelect}
    />
  )
}
